'use es6';

import { CUSTOM, CES, NPS, CSAT } from 'feedback-schema/constants/surveyTypes';

export const isCesSurvey = (type = '') => type === CES;
export const isNpsSurvey = (type = '') => type === NPS;
export const isCsatSurvey = (type = '') => type === CSAT;
export const isCustomSurvey = (type = '') => type === CUSTOM;
